import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { usePropertyArticlesCount } from '@/hooks/inventory/usePropertyArticlesCount';

interface PropertyWithArticles {
  id: string;
  title: string;
  short_name: string | null;
  images: string[];
}

interface PropertiesArticlesTableProps {
  properties: PropertyWithArticles[];
  onViewArticles: (propertyId: string) => void;
}

export default function PropertiesArticlesTable({ properties, onViewArticles }: PropertiesArticlesTableProps) {
  const propertyIds = properties.map(p => p.id);
  const { getCount, isLoading: isLoadingCounts } = usePropertyArticlesCount(propertyIds);

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Propiedad</TableHead>
            <TableHead>Artículos</TableHead>
            <TableHead className="text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {properties.map((property) => {
            const articlesCount = getCount(property.id);
            
            return (
              <TableRow key={property.id}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    {property.images?.[0] && (
                      <img
                        src={property.images[0]}
                        alt={property.title}
                        className="h-10 w-10 rounded-lg object-cover"
                      />
                    )}
                    <div>
                      <div className="font-medium">
                        {property.short_name || property.title}
                      </div>
                      {property.short_name && (
                        <div className="text-sm text-muted-foreground">
                          {property.title}
                        </div>
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {isLoadingCounts ? (
                    <span className="text-muted-foreground">...</span>
                  ) : (
                    <Badge variant="outline">
                      {articlesCount} artículo{articlesCount !== 1 ? 's' : ''}
                    </Badge>
                  )}
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onViewArticles(property.id)}
                  >
                    <Eye className="h-4 w-4 mr-1" />
                    Ver artículos
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
